import React from 'react'
import { Navigate,useLocation } from 'react-router-dom'
import { Outlet } from 'react-router-dom';
import Header from '../../components/admin/header';
import Sidebar from '../../components/admin/sidebar';

const Admin = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const currentRoute = useLocation().pathname.toLowerCase();
    if(!User){
      return <Navigate to={"/login?redirecturi="+currentRoute}/>
    }
    else{
      if(User.role !== 'admin'){
          return <Navigate to={"/login?redirecturi="+currentRoute}/>
      }
    }
  return (
    <>
      <Header locUser={User}/>
      <div className='body_admin'>
        <div className='admin_sidebar_container'>
          <Sidebar/>
        </div>
        <div className='admin_outlet_container'>
          <Outlet />
        </div>
      </div>
    </>
  )
}

export default Admin
